<template lang="pug">
div.main
  v-row(no-gutters)
    v-col.pa-8(cols="3")
      patient-profile-details
    v-divider(vertical)
    v-col.pa-8(cols="9")
      patient-profile-tabs
</template>

<script>
import PatientProfileDetails from '@/components/hq/patient/PatientProfileDetails.vue'
import PatientProfileTabs from '@/components/hq/patient/PatientProfileTabs.vue'

export default {
  components: {
    PatientProfileDetails, PatientProfileTabs
  },
}
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100% !important;
  height: 100% !important;
}
</style>